export const DECK_SIZE_LIMIT = 60;
export const MAX_COPIES_PER_CARD = 4;
export const MEMBER_CARD_LIMIT = 48;
export const LIVE_CARD_LIMIT = 12;
export const ENERGY_CARD_LIMIT = 12;
export const INITIAL_ENERGY_COUNT = 3;

export const LOCAL_DATA_URL = '/data/cards.json';
export const REMOTE_DATA_URL = 'https://script.google.com/macros/s/AKfycbzY7wwoUZpsb8fLapBZcs8ZdSyiWt3E1wDRj7xLN_wTgS-mEk1IaoH_9yE34BRzRxQJXw/exec';

export const CARD_TYPE_MEMBER = 'メンバー';
export const CARD_TYPE_LIVE = 'ライブ';
export const CARD_TYPE_ENERGY = 'エネルギー';

export const ENERGY_CARD_ID = "LL-E-001-SD";
export const ENERGY_CARD_NAME = "エネルギー";
export const ENERGY_CARD_IMG = "https://llofficial-cardgame.com/wordpress/wp-content/images/cardlist/PLSD01/LL-E-001-SD.png";
